import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcEuro = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.7526 14.9583C11.6629 14.9593 10.5939 14.6605 9.66265 14.0947C8.73139 13.5288 7.97373 12.7176 7.4726 11.75H12.7526L13.6693 9.91667H6.8676C6.82177 9.61417 6.79427 9.31167 6.79427 9C6.79427 8.68834 6.82177 8.38584 6.8676 8.08334H12.7526L13.6693 6.25H7.4726C7.97462 5.28309 8.73248 4.47257 9.66355 3.90682C10.5946 3.34107 11.6631 3.04181 12.7526 3.04167C14.2284 3.04167 15.5851 3.5825 16.6301 4.48084L18.2526 2.85834C16.7432 1.49935 14.7836 0.74817 12.7526 0.750003C9.15927 0.750003 6.11594 3.05084 4.97927 6.25H1.7526L0.835938 8.08334H4.5576C4.48336 8.69219 4.48336 9.30781 4.5576 9.91667H1.7526L0.835938 11.75H4.97927C6.11594 14.9492 9.15927 17.25 12.7526 17.25C14.8701 17.25 16.7951 16.4525 18.2526 15.1417L16.6209 13.5192C15.5851 14.4175 14.2376 14.9583 12.7526 14.9583Z" })
});
export default SvgIcEuro;
